/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const SmsKeywordIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0)" fill={color}>
        <rect x="7.556" y="6.083" width="3.556" height=".444" rx=".222" />
        <rect x="7.556" y="9.639" width=".889" height=".444" rx=".222" />
        <rect x="11.556" y="6.083" width="3.111" height=".444" rx=".222" />
        <rect x="8.889" y="9.639" width="3.111" height=".444" rx=".222" />
        <rect x="7.556" y="7.861" width="2.222" height=".444" rx=".222" />
        <rect x="10.222" y="7.417" width="4.444" height="1.333" rx=".667" />
        <path d="M14.912 4.328H9.885v-2.57a.947.947 0 00-.947-.946H.915a.947.947 0 00-.946.947v14.016c0 .522.424.946.946.946h8.023a.947.947 0 00.947-.946v-2.533l.991-1.143h1.022a.315.315 0 000-.631h-1.166a.315.315 0 00-.238.109l-.94 1.084-1.055-1.096a.316.316 0 00-.227-.097H7.256a.426.426 0 01-.426-.426V5.385c0-.235.191-.426.426-.426h7.656c.235 0 .426.191.426.426v5.657a.426.426 0 01-.426.426h-.49a.315.315 0 100 .63h.49c.583 0 1.057-.474 1.057-1.056V5.385c0-.583-.474-1.057-1.057-1.057zM.6 1.758c0-.173.141-.315.315-.315h8.023c.174 0 .316.142.316.316v1.026H.6V1.759zm8.654 14.017a.316.316 0 01-.316.315H.915a.316.316 0 01-.315-.315v-1.21h8.654v1.21zM6.199 5.385v5.657c0 .582.474 1.057 1.057 1.057h.882l1.116 1.16v.676H.6V3.415h8.654v.913H7.256c-.583 0-1.057.474-1.057 1.057z" />
        <path d="M3.696 15.643h2.46a.315.315 0 100-.63h-2.46a.315.315 0 100 .63zM5.505 1.864H4.348a.315.315 0 000 .63h1.157a.315.315 0 000-.63zM3.265 12.746H1.877v-1.42a.315.315 0 00-.63 0v1.736c0 .174.14.315.315.315h1.703a.315.315 0 100-.63zM4.607 12.76L4.6 12.76a.315.315 0 10-.18.604l.006.002a.315.315 0 00.181-.604zM13.25 11.521l-.007-.002a.315.315 0 10-.18.605l.006.002a.317.317 0 00.393-.212.315.315 0 00-.212-.393z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
